module.exports = __webpack_public_path__ + "media/images/lp_v6_reserve_txt01-a13f9502e67fc0b2d7705975e6b48bce.webp";